// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file sidecar/v1/scanner_local_api.proto (package sidecar.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sidecar/v1/scanner_local_api.proto.
 */
export const file_sidecar_v1_scanner_local_api: GenFile = /*@__PURE__*/
  fileDesc("CiJzaWRlY2FyL3YxL3NjYW5uZXJfbG9jYWxfYXBpLnByb3RvEgpzaWRlY2FyLnYxIvIBCgtTY2FubmVySW5mbxISCgpzY2FubmVyX2lkGAEgASgJEhEKCXVuaXF1ZV9pZBgCIAEoCRIUCgxkaXNwbGF5X25hbWUYAyABKAkSEwoLZHJpdmVyX3R5cGUYBCABKAkSFAoMbWFudWZhY3R1cmVyGAUgASgJEg0KBW1vZGVsGAYgASgJEhgKEGZpcm13YXJlX3ZlcnNpb24YByABKAkSDgoGb25saW5lGAggASgIEiIKGnN1cHBvcnRzX2RvY3VtZW50X3ByZXNlbmNlGAkgASgIEh4KFnN1cHBvcnRzX2ltYWdlX2NhcHR1cmUYCiABKAgiFQoTTGlzdFNjYW5uZXJzUmVxdWVzdCJBChRMaXN0U2Nhbm5lcnNSZXNwb25zZRIpCghzY2FubmVycxgBIAMoCzIXLnNpZGVjYXIudjEuU2Nhbm5lckluZm8iKwoVR2V0U2Nhbm5lckluZm9SZXF1ZXN0EhIKCnNjYW5uZXJfaWQYASABKAkiQgoWR2V0U2Nhbm5lckluZm9SZXNwb25zZRIoCgdzY2FubmVyGAEgASgLMhcuc2lkZWNhci52MS5TY2FubmVySW5mbyKDAQoTU2NhbkRvY3VtZW50UmVxdWVzdBISCgpzY2FubmVyX2lkGAEgASgJEiwKBmZvcm1hdBgCIAEoDjIcLnNpZGVjYXIudjEuU2Nhbk91dHB1dEZvcm1hdBISCgp0aW1lb3V0X21zGAMgASgFEhYKDmluY2x1ZGVfaW1hZ2VzGAQgASgIIj4KCVNjYW5JbWFnZRINCgVsYWJlbBgBIAEoCRIMCgRkYXRhGAIgASgMEhQKDGNvbnRlbnRfdHlwZRgDIAEoCSIiCgtSYXdTY2FuRGF0YRITCgtyYXdfcGF5bG9hZBgBIAEoCSIoCgpBYW12YUZpZWxkEgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCSKVAwoJQWFtdmFEYXRhEhMKC3Jhd19wYXlsb2FkGAEgASgJEiYKBmZpZWxkcxgCIAMoCzIWLnNpZGVjYXIudjEuQWFtdmFGaWVsZBIWCg5wZGY0MTdfcGF5bG9hZBgDIAEoCRIWCg5wZGY0MTdfZGVjb2RlZBgEIAEoCBIZChFwZGY0MTdfY29uZmlkZW5jZRgFIAEoAhIqCgpvY3JfZmllbGRzGAYgAygLMhYuc2lkZWNhci52MS5BYW12YUZpZWxkEhAKCG9jcl90ZXh0GAcgASgJEhwKFHBvcnRyYWl0X2ltYWdlX2xhYmVsGAggASgJEhkKEWZyb250X2ltYWdlX2xhYmVsGAkgASgJEhgKEGJhY2tfaW1hZ2VfbGFiZWwYCiABKAkSOwoLZGlhZ25vc3RpY3MYCyADKAsyJi5zaWRlY2FyLnYxLkFhbXZhRGF0YS5EaWFnbm9zdGljc0VudHJ5GjIKEERpYWdub3N0aWNzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASKeAgoUU2NhbkRvY3VtZW50UmVzcG9uc2USEgoKZWxhcHNlZF9tcxgBIAEoBRIlCgZpbWFnZXMYAiADKAsyFS5zaWRlY2FyLnYxLlNjYW5JbWFnZRImCgNyYXcYAyABKAsyFy5zaWRlY2FyLnYxLlJhd1NjYW5EYXRhSAASJgoFYWFtdmEYBCABKAsyFS5zaWRlY2FyLnYxLkFhbXZhRGF0YUgAEkAKCG1ldGFkYXRhGAUgAygLMi4uc2lkZWNhci52MS5TY2FuRG9jdW1lbnRSZXNwb25zZS5NZXRhZGF0YUVudHJ5Gi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUIICgZyZXN1bHQqcAoQU2Nhbk91dHB1dEZvcm1hdBIiCh5TQ0FOX09VVFBVVF9GT1JNQVRfVU5TUEVDSUZJRUQQABIaChZTQ0FOX09VVFBVVF9GT1JNQVRfUkFXEAESHAoYU0NBTl9PVVRQVVRfRk9STUFUX0FBTVZBEAIylAIKE1NjYW5uZXJMb2NhbFNlcnZpY2USUQoMTGlzdFNjYW5uZXJzEh8uc2lkZWNhci52MS5MaXN0U2Nhbm5lcnNSZXF1ZXN0GiAuc2lkZWNhci52MS5MaXN0U2Nhbm5lcnNSZXNwb25zZRJXCg5HZXRTY2FubmVySW5mbxIhLnNpZGVjYXIudjEuR2V0U2Nhbm5lckluZm9SZXF1ZXN0GiIuc2lkZWNhci52MS5HZXRTY2FubmVySW5mb1Jlc3BvbnNlElEKDFNjYW5Eb2N1bWVudBIfLnNpZGVjYXIudjEuU2NhbkRvY3VtZW50UmVxdWVzdBogLnNpZGVjYXIudjEuU2NhbkRvY3VtZW50UmVzcG9uc2VCLFoqcGFja2FnZXMvc2VydmljZS1zaWRlY2FyL2FwaS92MTtzaWRlY2FyX3YxYghlZGl0aW9uc3DoBw");

/**
 * @generated from message sidecar.v1.ScannerInfo
 */
export type ScannerInfo = Message<"sidecar.v1.ScannerInfo"> & {
  /**
   * @generated from field: string scanner_id = 1;
   */
  scannerId: string;

  /**
   * @generated from field: string unique_id = 2;
   */
  uniqueId: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string driver_type = 4;
   */
  driverType: string;

  /**
   * @generated from field: string manufacturer = 5;
   */
  manufacturer: string;

  /**
   * @generated from field: string model = 6;
   */
  model: string;

  /**
   * @generated from field: string firmware_version = 7;
   */
  firmwareVersion: string;

  /**
   * @generated from field: bool online = 8;
   */
  online: boolean;

  /**
   * @generated from field: bool supports_document_presence = 9;
   */
  supportsDocumentPresence: boolean;

  /**
   * @generated from field: bool supports_image_capture = 10;
   */
  supportsImageCapture: boolean;
};

/**
 * Describes the message sidecar.v1.ScannerInfo.
 * Use `create(ScannerInfoSchema)` to create a new message.
 */
export const ScannerInfoSchema: GenMessage<ScannerInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 0);

/**
 * @generated from message sidecar.v1.ListScannersRequest
 */
export type ListScannersRequest = Message<"sidecar.v1.ListScannersRequest"> & {
};

/**
 * Describes the message sidecar.v1.ListScannersRequest.
 * Use `create(ListScannersRequestSchema)` to create a new message.
 */
export const ListScannersRequestSchema: GenMessage<ListScannersRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 1);

/**
 * @generated from message sidecar.v1.ListScannersResponse
 */
export type ListScannersResponse = Message<"sidecar.v1.ListScannersResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.ScannerInfo scanners = 1;
   */
  scanners: ScannerInfo[];
};

/**
 * Describes the message sidecar.v1.ListScannersResponse.
 * Use `create(ListScannersResponseSchema)` to create a new message.
 */
export const ListScannersResponseSchema: GenMessage<ListScannersResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 2);

/**
 * @generated from message sidecar.v1.GetScannerInfoRequest
 */
export type GetScannerInfoRequest = Message<"sidecar.v1.GetScannerInfoRequest"> & {
  /**
   * @generated from field: string scanner_id = 1;
   */
  scannerId: string;
};

/**
 * Describes the message sidecar.v1.GetScannerInfoRequest.
 * Use `create(GetScannerInfoRequestSchema)` to create a new message.
 */
export const GetScannerInfoRequestSchema: GenMessage<GetScannerInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 3);

/**
 * @generated from message sidecar.v1.GetScannerInfoResponse
 */
export type GetScannerInfoResponse = Message<"sidecar.v1.GetScannerInfoResponse"> & {
  /**
   * @generated from field: sidecar.v1.ScannerInfo scanner = 1;
   */
  scanner?: ScannerInfo;
};

/**
 * Describes the message sidecar.v1.GetScannerInfoResponse.
 * Use `create(GetScannerInfoResponseSchema)` to create a new message.
 */
export const GetScannerInfoResponseSchema: GenMessage<GetScannerInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 4);

/**
 * @generated from message sidecar.v1.ScanDocumentRequest
 */
export type ScanDocumentRequest = Message<"sidecar.v1.ScanDocumentRequest"> & {
  /**
   * @generated from field: string scanner_id = 1;
   */
  scannerId: string;

  /**
   * @generated from field: sidecar.v1.ScanOutputFormat format = 2;
   */
  format: ScanOutputFormat;

  /**
   * @generated from field: int32 timeout_ms = 3;
   */
  timeoutMs: number;

  /**
   * @generated from field: bool include_images = 4;
   */
  includeImages: boolean;
};

/**
 * Describes the message sidecar.v1.ScanDocumentRequest.
 * Use `create(ScanDocumentRequestSchema)` to create a new message.
 */
export const ScanDocumentRequestSchema: GenMessage<ScanDocumentRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 5);

/**
 * @generated from message sidecar.v1.ScanImage
 */
export type ScanImage = Message<"sidecar.v1.ScanImage"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message sidecar.v1.ScanImage.
 * Use `create(ScanImageSchema)` to create a new message.
 */
export const ScanImageSchema: GenMessage<ScanImage> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 6);

/**
 * @generated from message sidecar.v1.RawScanData
 */
export type RawScanData = Message<"sidecar.v1.RawScanData"> & {
  /**
   * @generated from field: string raw_payload = 1;
   */
  rawPayload: string;
};

/**
 * Describes the message sidecar.v1.RawScanData.
 * Use `create(RawScanDataSchema)` to create a new message.
 */
export const RawScanDataSchema: GenMessage<RawScanData> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 7);

/**
 * @generated from message sidecar.v1.AamvaField
 */
export type AamvaField = Message<"sidecar.v1.AamvaField"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message sidecar.v1.AamvaField.
 * Use `create(AamvaFieldSchema)` to create a new message.
 */
export const AamvaFieldSchema: GenMessage<AamvaField> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 8);

/**
 * @generated from message sidecar.v1.AamvaData
 */
export type AamvaData = Message<"sidecar.v1.AamvaData"> & {
  /**
   * @generated from field: string raw_payload = 1;
   */
  rawPayload: string;

  /**
   * @generated from field: repeated sidecar.v1.AamvaField fields = 2;
   */
  fields: AamvaField[];

  /**
   * @generated from field: string pdf417_payload = 3;
   */
  pdf417Payload: string;

  /**
   * @generated from field: bool pdf417_decoded = 4;
   */
  pdf417Decoded: boolean;

  /**
   * @generated from field: float pdf417_confidence = 5;
   */
  pdf417Confidence: number;

  /**
   * @generated from field: repeated sidecar.v1.AamvaField ocr_fields = 6;
   */
  ocrFields: AamvaField[];

  /**
   * @generated from field: string ocr_text = 7;
   */
  ocrText: string;

  /**
   * @generated from field: string portrait_image_label = 8;
   */
  portraitImageLabel: string;

  /**
   * @generated from field: string front_image_label = 9;
   */
  frontImageLabel: string;

  /**
   * @generated from field: string back_image_label = 10;
   */
  backImageLabel: string;

  /**
   * @generated from field: map<string, string> diagnostics = 11;
   */
  diagnostics: { [key: string]: string };
};

/**
 * Describes the message sidecar.v1.AamvaData.
 * Use `create(AamvaDataSchema)` to create a new message.
 */
export const AamvaDataSchema: GenMessage<AamvaData> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 9);

/**
 * @generated from message sidecar.v1.ScanDocumentResponse
 */
export type ScanDocumentResponse = Message<"sidecar.v1.ScanDocumentResponse"> & {
  /**
   * @generated from field: int32 elapsed_ms = 1;
   */
  elapsedMs: number;

  /**
   * @generated from field: repeated sidecar.v1.ScanImage images = 2;
   */
  images: ScanImage[];

  /**
   * @generated from oneof sidecar.v1.ScanDocumentResponse.result
   */
  result: {
    /**
     * @generated from field: sidecar.v1.RawScanData raw = 3;
     */
    value: RawScanData;
    case: "raw";
  } | {
    /**
     * @generated from field: sidecar.v1.AamvaData aamva = 4;
     */
    value: AamvaData;
    case: "aamva";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message sidecar.v1.ScanDocumentResponse.
 * Use `create(ScanDocumentResponseSchema)` to create a new message.
 */
export const ScanDocumentResponseSchema: GenMessage<ScanDocumentResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scanner_local_api, 10);

/**
 * @generated from enum sidecar.v1.ScanOutputFormat
 */
export enum ScanOutputFormat {
  /**
   * @generated from enum value: SCAN_OUTPUT_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCAN_OUTPUT_FORMAT_RAW = 1;
   */
  RAW = 1,

  /**
   * @generated from enum value: SCAN_OUTPUT_FORMAT_AAMVA = 2;
   */
  AAMVA = 2,
}

/**
 * Describes the enum sidecar.v1.ScanOutputFormat.
 */
export const ScanOutputFormatSchema: GenEnum<ScanOutputFormat> = /*@__PURE__*/
  enumDesc(file_sidecar_v1_scanner_local_api, 0);

/**
 * @generated from service sidecar.v1.ScannerLocalService
 */
export const ScannerLocalService: GenService<{
  /**
   * @generated from rpc sidecar.v1.ScannerLocalService.ListScanners
   */
  listScanners: {
    methodKind: "unary";
    input: typeof ListScannersRequestSchema;
    output: typeof ListScannersResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.ScannerLocalService.GetScannerInfo
   */
  getScannerInfo: {
    methodKind: "unary";
    input: typeof GetScannerInfoRequestSchema;
    output: typeof GetScannerInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.ScannerLocalService.ScanDocument
   */
  scanDocument: {
    methodKind: "unary";
    input: typeof ScanDocumentRequestSchema;
    output: typeof ScanDocumentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sidecar_v1_scanner_local_api, 0);

